export default __webpack_public_path__ + "static/media/makeup.ffcda397.jpeg";